exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueTables--client .table-responsive .ps__rail-x,.VueTables--client .table-responsive .ps__rail-y{background-color:#fff!important;opacity:1!important}.VueTables--client .VuePagination{padding-top:1rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b1e9bad","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/App.vue
// module id = HROj
// module chunks = 1